import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { CallCenterLayoutComponent } from './call-center-layout/call-center-layout.component';
import { LayoutSidebarComponent } from './call-center-layout/layout-sidebar/layout-sidebar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { CallCenterRoutingModule } from './call-center-routing.module';
import { NgbCollapseModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { MaterialModule } from '../material/material-module';
import { LightboxModule } from 'ngx-lightbox';
import { CoreModule } from '@angular/flex-layout';
import { SharedModule } from '../shared/shared.module';
import { UserService } from '../core/services/v2/user.service';
import { AuthService } from '../auth/auth.service';
import { LoginGuard } from '../auth/loginGuard';
import { LayoutHeaderComponent } from './call-center-layout/layout-header/layout-header.component';
import { CallCenterComponent } from './call-center.component';
import { CallCenterAppointmentComponent } from './call-center-appointment/call-center-appointment.component';
import { CallCenterAppointmentDialogComponent } from './call-center-appointment-dialog/call-center-appointment-dialog.component';
import { CallCenterDashboardComponent } from './call-center-dashboard/call-center-dashboard.component';
import { CallCenterHeaderFilterComponent } from './call-center-layout/call-center-header-filter/call-center-header-filter.component';
import { CallCenterMembersSearchComponent } from './call-center-members-search/call-center-members-search.component';



@NgModule({
  declarations: [
    CallCenterLayoutComponent,
    LayoutHeaderComponent,
    LayoutSidebarComponent,
    CallCenterComponent,
    CallCenterAppointmentComponent,
    CallCenterAppointmentDialogComponent,
    CallCenterDashboardComponent,
    CallCenterHeaderFilterComponent,
    CallCenterMembersSearchComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    CallCenterRoutingModule,
    NgbModalModule,
    NgbCollapseModule,
    MaterialModule,
    LightboxModule,
    CoreModule,
    SharedModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    UserService,
    AuthService,
    LoginGuard,
    DatePipe
  ],
  entryComponents: [
    CallCenterAppointmentDialogComponent
  ],
  bootstrap: [CallCenterLayoutComponent]
})
export class CallCenterModule { }
